<template>
  <div>
    <b-card title="权限设置" class="mb-0">
      <div style="margin-left: -1.5rem; margin-right: -1.5rem;">
        <div class="m-sm-2 m-1">
          <b-row>
            <b-col>
              <div class="d-flex align-items-center">
                <b-button variant="primary" @click="operate">
                  <span class="text-nowrap">添加权限</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        <!-- 表格 -->
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="tableData"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          :empty-text="!loading ? '暂无数据' : '数据加载中...'"
          :no-provider-paging="false"
          stacked="md"
        >
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(status)="data">
            <b-badge
              v-if="data.value == 1"
              href="javascript:void(0)"
              variant="success"
              >启用</b-badge
            >
            <b-badge v-else href="javascript:void(0)" variant="danger"
              >禁用</b-badge
            >
          </template>
          <template v-slot:cell(auto_audit)="data">
            <b-badge
              v-if="data.value == 1"
              href="javascript:void(0)"
              variant="success"
              >自动通过</b-badge
            >
            <b-badge v-else href="javascript:void(0)" variant="warning"
              >需审批</b-badge
            >
          </template>
          <template v-slot:cell(actions)="data">
            <div style="min-width: 8rem;">
              <a class="mr-1" href="javascript:void(0)" @click="operate(data)"
                >修改</a
              >
              <a href="javascript:void(0)" @click="del(data)">删除</a>
            </div>
          </template>
        </b-table>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSidebar,
} from "bootstrap-vue";
import vSelect from "vue-select";
import moment from "moment";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSidebar,
    vSelect,
  },
  data() {
    return {
      page: 1,
      perPage: 10,
      totalRows: 0,
      perPageOptions: [10, 20, 50, 100],
      tableData: [],
      tableColumns: [
        {
          key: "index",
          label: "序号",
        },
        {
          key: "business_name",
          label: "业务名称",
          sortable: true,
        },
        {
          key: "name",
          label: "权限名称",
          sortable: true,
        },
        {
          key: "detail",
          label: "权限描述",
          sortable: true,
        },
        {
          key: "status",
          label: "状态",
          sortable: true,
        },
        {
          key: "auto_audit",
          label: "自动审批",
          sortable: true,
        },
        {
          key: "actions",
          label: "操作",
        },
      ],
      loading: false,
      showDetail: false,
    };
  },
  created() {
    if (this.$route.name == this.OperateRouterName) {
      this.showDetail = true;
    }
    this.loadData();
  },
  methods: {
    loadData() {
      this.tableData = [];
      this.loading = true;
      this.$http
        .get("/Business/GetBusinessScopeList")
        .then((u) => {
          this.loading = false;
          this.tableData = u;
          this.totalRows = u.Count;
        })
        .catch((u) => {
          this.loading = false;
        });
    },
    operate(data) {
      var id = data && data.item ? data.item.id : undefined;
      this.$router.push({
        name: "BusinessEdit",
        params: {
          id,
        },
      });
    },
    scope(data) {
      var id = data && data.item ? data.item.id : undefined;
      if (!id) {
        this.$alertError("缺少权限参数");
        return;
      }
      this.$router.push({
        name: "BusinessEdit",
        params: {
          id,
        },
      });
    },
    del(data) {
      this.$confirm("确定要删除该条记录吗？").then(() => {
        this.$http
          .get("/Business/DeleteBusinessScope", {
            params: {
              id: data.item.id,
            },
          })
          .then((u) => {
            this.loadData();
            this.$alertSuccess("删除权限成功");
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>
